import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import MainMenu from "../Components/Main_Menu";
import Search from "./Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const videoData = [
  {
    id: 1,
    src: "https://dongsooo.github.io/imgs/dongstagram_vdo/05_shorts_vdo1.mp4",
    title: "비디오 1",
    name: "mudoMania",
    comment: "쓰읍~ 난 좀 반댄데..",
    likeNums: "1.5만",
    userSrc:
      "https://dongsooo.github.io/imgs/dongstgram_img/04_video_user_img1.jpg",
  },
  {
    id: 2,
    src: "https://dongsooo.github.io/imgs/dongstagram_vdo/05_shorts_vdo2.mp4",
    title: "비디오 2",
    name: "iLoveEspa",
    comment: "수 수 수 수퍼노바~",
    likeNums: "4.7만",
    userSrc:
      "https://dongsooo.github.io/imgs/dongstgram_img/04_video_user_img2.jpg",
  },
  {
    id: 3,
    src: "https://dongsooo.github.io/imgs/dongstagram_vdo/05_shorts_vdo3.mp4",
    title: "비디오 3",
    name: "iAmPirateKing",
    comment: "드디어 나온 갤럭시임팩트!!",
    likeNums: "1만",
    userSrc:
      "https://dongsooo.github.io/imgs/dongstgram_img/04_video_user_img3.jpg",
  },
  // 추가 비디오 데이터...
];

const Video = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isPlaying, setIsPlaying] = useState(null);
  const [isMuted, setIsMuted] = useState(true);
  const [likedVideos, setLikedVideos] = useState({});
  const [progress, setProgress] = useState({});
  const videoRefs = useRef({});
  const observer = useRef(null);

  useEffect(() => {
    // IntersectionObserver 설정
    observer.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (video && video instanceof Element) {
            if (entry.isIntersecting) {
              // 비디오가 화면에 보일 때
              if (isPlaying === video.dataset.id) {
                video.play(); // 클릭으로 재생 중인 비디오만 재생
              }
            } else {
              // 비디오가 화면에서 벗어날 때
              video.pause(); // 비디오 정지
              if (isPlaying === video.dataset.id) {
                setIsPlaying(null); // 비디오가 화면에서 벗어났다면 재생 중인 비디오 ID 초기화
              }
            }
          }
        });
      },
      { threshold: 0.5 }
    ); // 화면의 50%가 보일 때 감지

    // 모든 비디오 요소에 observer 적용
    Object.values(videoRefs.current).forEach((video) => {
      if (video && video instanceof Element) {
        observer.current.observe(video);
      }
    });

    return () => {
      // 컴포넌트 언마운트 시 observer 해제
      Object.values(videoRefs.current).forEach((video) => {
        if (video && video instanceof Element) {
          observer.current.unobserve(video);
        }
      });
    };
  }, [isPlaying]);

  // 비디오를 클릭했을 때 재생과 정지를 토글합니다
  const handlePlayPauseClick = (id) => {
    if (videoRefs.current[id]) {
      if (isPlaying === id) {
        videoRefs.current[id].pause(); // 비디오 정지
        setIsPlaying(null); // 재생 중인 비디오 id 초기화
      } else {
        // 모든 비디오를 정지시키고
        Object.keys(videoRefs.current).forEach((key) => {
          videoRefs.current[key].pause();
        });
        videoRefs.current[id].play(); // 선택한 비디오 재생
        setIsPlaying(id); // 재생 중인 비디오 id 설정
      }
    }
  };

  // 음소거 버튼 클릭 시 음소거 상태를 토글합니다
  const handleMuteToggle = (event) => {
    event.stopPropagation(); // 클릭 이벤트 전파를 막습니다
    setIsMuted(!isMuted); // 음소거 상태를 업데이트합니다
    Object.keys(videoRefs.current).forEach((key) => {
      videoRefs.current[key].muted = !isMuted; // 모든 비디오에 음소거 상태 적용
    });
  };

  // 좋아요 버튼 클릭 시 좋아요 상태를 토글합니다
  const handleLikeToggle = (id) => {
    setLikedVideos((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  // 비디오의 진행 상태를 업데이트하는 함수입니다
  const handleTimeUpdate = (id) => {
    const video = videoRefs.current[id];
    if (video) {
      const currentProgress = (video.currentTime / video.duration) * 100;
      setProgress((prevState) => ({
        ...prevState,
        [id]: currentProgress,
      }));
    }
  };

  return (
    <>
      <VideoWrap>
        <MainMenu />
        <VideoContentWrap>
          {videoData.map((video) => (
            <VideoContentBox key={video.id}>
              <div className="authorBox">
                <p className="authorPicture">
                  <img src={video.userSrc} alt="사용자이미지" />
                </p>
                <p className="authorID">{video.name}</p>
              </div>
              <div className="commentBox">
                <p>{video.comment}</p>
              </div>
              <VideoBox
                onClick={() => handlePlayPauseClick(video.id)}
                data-id={video.id}
              >
                <video
                  src={video.src}
                  ref={(el) => (videoRefs.current[video.id] = el)}
                  muted={isMuted}
                  onTimeUpdate={() => handleTimeUpdate(video.id)}
                >
                  {video.title}
                </video>
                <ProgressBar progress={progress[video.id] || 0} />
                <MuteButton onClick={handleMuteToggle}>
                  <FontAwesomeIcon
                    icon={
                      isMuted
                        ? "fa-solid fa-volume-xmark"
                        : "fa-solid fa-volume-high"
                    }
                  />
                </MuteButton>
              </VideoBox>
              <LikeBox>
                <p onClick={() => handleLikeToggle(video.id)}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-heart"
                    style={{
                      color: likedVideos[video.id] ? "red" : "",
                    }}
                  />
                </p>
                <p className="text">{video.likeNums}</p>
                <p>
                  <FontAwesomeIcon icon="fa-solid fa-comment" />
                </p>
                <p className="number">23</p>
              </LikeBox>
            </VideoContentBox>
          ))}
        </VideoContentWrap>
        <Search />
      </VideoWrap>
    </>
  );
};

export default Video;

const LoadingScreen = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  z-index: 9999; /* Ensure it is on top of all other elements */
`;

const VideoWrap = styled.div`
  width: 100%;
  min-width: 360px;
  padding-bottom: 40px;
  background-color: #efefef;

  @media (max-width: 767px) {
    margin-top: 40px;
    padding-bottom: 60px;
  }
`;

const VideoContentWrap = styled.div`
  width: calc(100% - 240px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  left: 120px;

  @media (max-width: 1264px) {
    width: calc(100% - 80px);
    left: 40px;
  }

  @media (max-width: 767px) {
    width: 100%;
    left: 0;
  }
`;

const VideoContentBox = styled.div`
  width: 500px;
  background-color: #c0c0c0;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  position: relative;
  height: calc(100vh - 50px);
  margin-top: 20px;
  margin-bottom: 20px;

  @media (max-width: 767px) {
    display: flex;
    max-width: 767px;
    width: 100%;
    height: calc(100vh - 110px);
    margin-bottom: 0;
  }

  .authorBox {
    display: flex;
    width: 97%;
    gap: 10px;
    align-items: center;
    margin-bottom: 10px;

    .authorPicture {
      position: relative;
      width: 13%;
      background-color: skyblue;
      border-radius: 50%;
      overflow: hidden;

      @media (max-width: 767px) {
        width: 50px;
      }

      &::after {
        display: block;
        content: "";
        padding-bottom: 100%;
      }

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 150%;
        height: 150%;
        object-fit: cover;
        border-radius: 50%;
      }
    }

    .authorID {
      text-align: start;
      width: 100%;
    }
  }

  .commentBox {
    font-size: 2em;
    font-weight: bold;
    margin-bottom: 20px;
  }
`;

const VideoBox = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;

  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  video {
    position: relative;
    width: 100%;
  }

  @media (max-width: 767px) {
    max-width: 767px;
    width: 100%;

    video {
      width: 100%;
    }
  }
`;

const MuteButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  color: white;

  @media (max-width: 767px) {
    position: absolute;
    top: 10%;
    right: 2%;
    transform: translateY(-50%);
  }
`;

const ProgressBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 5px;
  width: ${(props) => props.progress}%;
  background-color: red;
  transition: width 0.1s ease-in-out;
`;

const LikeBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 40px;
  bottom: 3%;
  right: 2%;
  padding-left: 5px;

  .fa-heart,
  .fa-comment {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.7em;
    margin-right: 2px;
    cursor: pointer;
    color: #868686;
  }
  .text,
  .number {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
    color: #868686;
    font-weight: 700;
  }
`;
